import * as actionTypes from "../actionTypes";
import {updateObject} from "../../shared/utils/updateObject";

const getUrlPart = () => {
    const host = window.location.hostname
    if (host.includes('operator'))
        return 'operatori'

    return 'fastweb'
}

const initialState = {
    selectedTab: 0,
    links: {
        reportTutteSim: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/ReportTutteSIM.html`,
        centriDiFatturazione: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/CentriDiFatturazione.html`,
        offerteFlex: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/OfferteBulk.html`,
        singolaSIMCerca: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/SingolaSIMCerca.html`,
        traffico: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/Traffico.html`,
        offerteBulk: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/newbulk.html`,
        soglieEventi: {
            prod: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/psi/psi.html`,
            int: `https://qesdevtest.fastweb.it/${getUrlPart()}/extensions/psi/psi.html`
        },
        ricariche: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/Ricariche.html`,
        plafondShare: `https://qapprod.fastweb.it/${getUrlPart()}/extensions/fastweb/Plafondshare.html`
    },
    selectedSimMsisdn: "",
    selectedBulk: ""
};

const setSelectedTab = (state, action) => {
    return updateObject(state, {selectedTab: action.selectedTab});
}

const setReportLinks = (state, action) => {
    return updateObject(state, {links: action.links})
}

const setSelectedSimMsisdn = (state, action) => {
    return updateObject(state, {selectedSimMsisdn: action.msisdn})
}

const setBulkGroupKey = (state, action) => {
    return updateObject(state, {selectedBulk: action.selectedBulk})
}

const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.REPORT_SET_SELECTED_TAB:
            return setSelectedTab(state, action);
        case actionTypes.SET_REPORT_LINKS:
            return setReportLinks(state, action);
        case actionTypes.SET_SINGLOA_MSISDN:
            return setSelectedSimMsisdn(state, action);
        case actionTypes.SET_BULK_GROUP_KEY_REPORT:
            return setBulkGroupKey(state, action);
        default:
            return state;
    }
};

export default reportReducer;
